import analytics from '../analytics'

export function userAddressRetrieve (apiClient, userId, addressIndex) {
  const pathTemplate = '/address'
  const method = 'GET'
  const params = {}
  const additionalParams = {
    queryParams: {
      userId,
      addressIndex
    }
  }
  const body = {}

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-address', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-address', end - start, 'error')
      console.log('Error retrieving user address %j', error)
      throw error
    })
}

export function userAddressUpdate (apiClient, userId, addressInfo) {
  const pathTemplate = '/address'
  const method = 'POST'
  const params = {}
  const additionalParams = {}
  const body = addressInfo

  // add the other necessary fields
  body.userId = userId

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-address', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-address', end - start, 'error')
      console.log('Error retrieving address %j', error)
      throw error
    })
}



// WEBPACK FOOTER //
// ./src/api/address.js